import { render, staticRenderFns } from "./NewsHistoryModal.vue?vue&type=template&id=3fc90e50&scoped=true"
import script from "./NewsHistoryModal.vue?vue&type=script&lang=js"
export * from "./NewsHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc90e50",
  null
  
)

export default component.exports